import { Icon } from '@iconify/react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import React from 'react';
import aboutImage from '../assets/images/skyfall-enterprises.png';

const AboutUsSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      window.location.hash = sectionId;
    }
  };

  return (
    <Box
      id='about'
      sx={{
        background: 'background.default',
        py: { xs: 6, md: 10 },
        color: '#fff',
      }}
    >
      <Container maxWidth='lg'>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={6}
          alignItems='center'
        >
          {/* Image/Illustration */}
          <Box sx={{ width: { xs: '100%', md: '50%' } }}>
            <Box
              sx={{
                width: '100%',
                height: { xs: '250px', md: '400px' },
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                overflow: 'hidden',
              }}
            >
              <img
                src={aboutImage}
                alt='About Us'
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Box>
          </Box>
          {/* Text Content */}
          <Box sx={{ width: { xs: '100%', md: '50%' } }}>
            <Typography
              variant='h4'
              component='h2'
              sx={{ fontWeight: 700, mb: 2 }}
            >
              About{' '}
              <Box component='span' sx={{ color: 'primary.main' }}>
                Skyfall Enterprises
              </Box>
            </Typography>
            <Typography variant='body1' sx={{ mb: 3, opacity: 0.8 }}>
              We are a data-driven software development company dedicated to
              empowering businesses with intelligent solutions. By seamlessly
              integrating software services with advanced data tracking, we
              provide in-depth, data-driven reporting that enables businesses to
              make informed and strategic decisions. Our expertise lies in
              transforming raw data into actionable insights, helping companies
              optimize their operations, enhance performance, and drive
              sustainable growth. At Skyfall Enterprises, we bridge the gap
              between technology and business intelligence, ensuring that every
              decision is backed by accurate and meaningful data.
            </Typography>
            <Button
              variant='outlined'
              size='large'
              startIcon={<Icon icon='mdi:arrow-right' />}
              onClick={() => scrollToSection('contactus')}
              sx={{
                color: '#fff',
                borderColor: 'rgba(255,255,255,0.5)',
                '&:hover': {
                  borderColor: '#fff',
                  bgcolor: 'rgba(255,255,255,0.05)',
                },
                borderRadius: '30px',
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              Let's Talk
            </Button>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default AboutUsSection;
